import { createFileRoute, redirect } from '@tanstack/react-router';
import { requirePermissions } from '@/shared/utils';
import { AdvisoriesPage } from '../../../features/advisory/components';

export const Route = createFileRoute('/_app/advisories/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['parties.advisories.read']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  return <AdvisoriesPage />;
}
